import {Directive, ElementRef, EventEmitter, Input, Output, QueryList, Renderer2} from '@angular/core';
import {CONFIG} from "../app/config";

@Directive({
    selector: '[writer]',
    host: {},
    providers: []
})
export class WriterDirective {

    config: any;

    @Input('writer') writer: boolean = true; // só recebe o default 20 caso a propriedade seja [badge]="", se for apenas hotkeys ou hotkeys="" não recebe (e se estiver omitida?)
    @Input('writer-speed') writerSpeed: number = 30; // só recebe o default 30 caso a propriedade seja [badge]="", se for apenas hotkeys ou hotkeys="" não recebe (e se estiver omitida?)
    @Input('writer-color') writerColor: string = 'CorRoxa'; // color do "_" que fica piscando no final

    @Output('writer-started') writerStarted: EventEmitter<any> = new EventEmitter();    // click somente se não estiver this._requesting
    @Output('writer-ended') writerEnded: EventEmitter<any> = new EventEmitter();        // click somente se não estiver this._requesting

    private _element: HTMLElement;
    private _html: string;
    private _writers: QueryList<WriterDirective>;
    private _intervalID: number;
    private _pos: number = 0;
    private _tagAberta: boolean = false;

    constructor(public element: ElementRef, public renderer: Renderer2) {

        this.config = CONFIG;
        this._element = element.nativeElement;

    }

    ngAfterViewInit() {

        if (!this.writerSpeed) return;

        this.prepareWriter();

        if (this.writer && this._html && this._html.length) this.startLoader();

        setTimeout(() => this.writerStarted.emit(this));

        //this.writerStarted.emit(this);

    }

    prepareWriter() {

        if (!this._element.innerHTML) return;

        this._element.style.height = this._element.offsetHeight + 'px';

        this._html = this._element.innerHTML;
        this._element.innerHTML = '';
        this.renderer.removeClass(this._element, 'writer-writed');

        //Replaces...
        while (this._html.indexOf('&nbsp;') != -1) this._html = this._html.replace('&nbsp;', ' ');
    }

    startLoader(clear: boolean = false) {

        let timeout = (!this.writerSpeed ? 0 : (1000 / this.writerSpeed));

        setTimeout(() => {

            if (this._element.className.indexOf('writer-writing') >= 0) return;
            if (clear) this.prepareWriter();
            if (this._element.className.indexOf('writer-writed') >= 0) return;

            this._pos = 0;
            this.renderer.addClass(this._element, 'writer-writing');

            this._intervalID = setInterval(() => this.renderLetter(this._html), timeout);

        });

    }

    setWriters(writers) {

        this._writers = writers;

    }

    renderLetter(html) {

        if (!html) {
            clearTimeout(this._intervalID);
            return;
        }

        if (html.length == this._pos) {

            this.renderer.removeClass(this._element, 'writer-writing');
            this.renderer.addClass(this._element, 'writer-writed');

            this.writerEnded.emit(this);

            let wnext: number = 0;

            if (this._writers) {
                this._writers.forEach((item, index) => {
                    if (item == this) wnext = index + 1;
                    if (wnext == index) setTimeout(() => item.startLoader(), 700);
                });
            }

            if (this.writerSpeed && (!this._writers || this._writers.length == wnext) && !this._element.querySelector('.writer-span')) {
                //GAMBI - Nao pode usar "ion-text color="CorRoxa" tem que usar "text text-ios text-ios-CorRoxa"
                if (this.writerColor) this._element.innerHTML += '<span class="writer-span animated infinite animate-blink font-bold text text-ios text-ios-' + this.writerColor + '"> _</span>';
            }

            clearTimeout(this._intervalID);
            return;

        }

        let tag = '';

        //Entende abertura e Fechamento de <TAG>
        if (html[this._pos] == '<') {

            while (html[this._pos] != '>') tag += html[this._pos++];

            tag += '>';
            this._pos++;

            this._tagAberta = !this._tagAberta;

            if (this._tagAberta) {
                this._element.innerHTML += tag; //<b> o InnerHTML vai colocar automatico o fechamento </b>

                //Entende elementos que nao tem fechamento <br/>, <img/>, ...
                let tagArray = ['img', 'br', 'input'];
                let tagFind = tagArray.filter( tagX => {
                    return (tag.substr(1, tagX.length) == tagX);
                }).length;

                if (tagFind) this._tagAberta = false;
            }

            return;
        }


        let elemAppend: any;

        //Seleciona ultima <TAG>
        if (this._tagAberta) {
            elemAppend = this._element.querySelectorAll('*');
            elemAppend = elemAppend[elemAppend.length - 1];
        }
        //Seleciona elemento raiz
        else {
            elemAppend = this._element;
        }

        //Escreve na raiz ou dentro de uma <TAG>
        elemAppend.innerHTML += html[this._pos++];

    }

}



// WEBPACK FOOTER //
// ./src/directives/writer.ts